import { createContext, useContext, ReactNode } from 'react';

import { useMeasure } from '../../shared/hooks/useMeasure';

type DossierLayoutInfoContextValue = {
    firstColumnWidth: number;
    isFirstColumnNarrow: boolean;
    firstColumnRef: (node: HTMLDivElement | null) => void;
};

const DossierLayoutInfoContext = createContext<DossierLayoutInfoContextValue | undefined>(
    undefined,
);

type DossierLayoutInfoProviderProps = {
    children: ReactNode;
    firstColumnNarrowThreshold?: number;
};

export const DossierLayoutInfoProvider = ({
    children,
    firstColumnNarrowThreshold = 420,
}: DossierLayoutInfoProviderProps) => {
    const [ref, { width }] = useMeasure<HTMLDivElement>();

    const value: DossierLayoutInfoContextValue = {
        firstColumnWidth: width,
        isFirstColumnNarrow: width > 0 && width < firstColumnNarrowThreshold,
        firstColumnRef: ref,
    };

    return (
        <DossierLayoutInfoContext.Provider value={value}>
            {children}
        </DossierLayoutInfoContext.Provider>
    );
};

export const useDossierLayoutInfo = (): DossierLayoutInfoContextValue => {
    const context = useContext(DossierLayoutInfoContext);
    if (context === undefined) {
        throw new Error('useDossierLayoutInfo must be used within a DossierLayoutInfoProvider');
    }
    return context;
};
